import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { api } from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem('rec_admin_token'));
  const [email, setEmail] = useState(() => localStorage.getItem('rec_admin_email'));
  const [checking, setChecking] = useState(true);

  const verify = useCallback(async () => {
    if (!token) {
      setChecking(false);
      return;
    }
    try {
      const { data } = await api.get('/auth/me');
      setEmail(data.email);
      localStorage.setItem('rec_admin_email', data.email);
    } catch (e) {
      localStorage.removeItem('rec_admin_token');
      localStorage.removeItem('rec_admin_email');
      setToken(null);
      setEmail(null);
    } finally {
      setChecking(false);
    }
  }, [token]);

  useEffect(() => {
    verify();
  }, [verify]);

  const login = useCallback(async (emailIn, password) => {
    const { data } = await api.post('/auth/login', { email: emailIn, password });
    localStorage.setItem('rec_admin_token', data.token);
    localStorage.setItem('rec_admin_email', data.email);
    setToken(data.token);
    setEmail(data.email);
    return data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('rec_admin_token');
    localStorage.removeItem('rec_admin_email');
    setToken(null);
    setEmail(null);
  }, []);

  const value = useMemo(() => ({ token, email, checking, isAuthed: !!token, login, logout }), [token, email, checking, login, logout]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
